import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=17badfa2&"
import script from "./GroupForm.controller.js?vue&type=script&lang=js&"
export * from "./GroupForm.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./GroupForm.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "757286f4"
  
)

export default component.exports